import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

class ReservationsDashboardWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      loading: true,
      // daily_rentals: false
    };
  }

  componentDidMount() {
    this.load();
  }

  render() {
    return (
      <div
        className={
          "ReservationsDashboardWidget WidgetComponent " +
          (this.state.loading ? "loading " : " ")
        }
      >
        {this.state.data ? <Dashboard daily_rentals={false} {...this.state.data} /> : null}
        <LoadingSpinner size="small" show={this.state.loading} />
      </div>
    );
  }

  load() {
    var self = this;
    this.setState({ loading: true });
    $.ajax({
      type: "POST",
      url: "/admin/reservations-dashboard-widget",
      data: {
        date: self.props.date,
        home_show: self.props.home_show,
      },
    }).done((data) => {
      self.setState({ loading: false, data: data });
    });
  }
}

export default ReservationsDashboardWidget;
